# GraphQL fragment to get basic info about a step template
# within the sales automation environment.

#import "../fragments/sales-automation-step-template.graphql"

query StepTemplatesForStageQuery($stageId: ID!) {
    editableStepTemplates(stageId: $stageId) {
        ...SalesAutomationStepTemplate
    }
}
